import {createSlice} from '@reduxjs/toolkit'

const initialDataAnonymizationState = {
  requests: null,
}

export const DataAnonymizationSlices = createSlice({
  name: 'dataAnonymization',
  initialState: initialDataAnonymizationState,
  reducers: {},
})
